<template>
  <ConfirmModal
    :title="user.twoFactorEnabled ? 'Disable Two-Factor Authentication' : 'Enable Two-Factor Authentication'"
    :confirm-text="user.twoFactorEnabled ? 'Disable for All Users' : 'Enable for All Users'"
    :confirm-type="user.twoFactorEnabled ? 'alert' : 'confirm'"
    :show-learn-more="true"
    learn-more-url="https://docs.knack.com/docs/2fa-setup-and-management"
    @confirm="confirmAction"
    @cancel="closeModal"
    @close="closeModal"
  >
    <template v-if="!user.twoFactorEnabled">
      <p>
        Are you sure you want to enable Two-Factor Authentication for all users?
      </p>
      <p>
        This will require all Live App users to verify their identity using email, password, and a
        two-factor authentication code to access protected pages:
      </p>
      <p>
        <ol>
          <li>
            Install a 2FA app such as Authy or Google Authenticator
          </li>
          <li>
            Scan a QR code or manually enter a secret key to add their Live App account to the app
          </li>
          <li>
            Enter the app-generated 6 digit code
          </li>
        </ol>
      </p>
    </template>

    <template v-if="user.twoFactorEnabled">
      <p>
        This will disable 2FA for <strong>ALL</strong> users in your organization
      </p>
      <p>
        All users will be able to log in with only their email and password.
      </p>
      <p>
        <ul>
          <li>If you enable 2FA again, users will need to reconfigure their mobile authenticator app.</li>
          <li>Once disabled, all 2FA settings will be completely removed from the system.</li>
        </ul>
      </p>
      <p>
        This action cannot be undone.
      </p>
    </template>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@/components/ui/ConfirmModal.vue';

export default {
  name: 'TwoFactorAuthenticationModal',
  components: {
    ConfirmModal,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'update-2fa-status'],
  methods: {
    closeModal() {
      this.$emit('close');
    },

    confirmAction() {
      // Emit the opposite of current status
      const newStatus = !this.user.twoFactorEnabled;
      this.$emit('update-2fa-status', newStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Ensure list styling is visible and properly indented */
ul {
  list-style-type: disc;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.5rem;
  }
}

ol {
  list-style-type: decimal;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.5rem;
  }
}
</style>
